import React from "react";
import { StyleClass } from "primereact/styleclass";
import { Link } from "react-router-dom";

export default function PartnersPageBox() {
  return (
    <div className="container contact-page-parent mx-auto px-6 py-10">
      <div className="surface-0">
        <div className="text-900 font-bold text-6xl mb-4 text-center">
          Become Partner
        </div>
        <div className="text-700 text-xl mb-6 text-center line-height-3">
          Join our partner ecosystem and play a key role in shaping the future
          of private 4G/5G connectivity. Whether you bring innovative solutions
          to our marketplace or expand our reach as a reseller, partnering with
          FlexNet opens the door to a world of opportunities.
        </div>

        <div className="grid">
          <div className="col-12 lg:col-6">
            <div className="p-3 h-full">
              <div
                className="chose-box  shadow-2 p-3 h-full flex flex-column"
                style={{ borderRadius: "6px" }}
              >
                <div className="text-900 font-medium text-xl mb-2">
                  Solution Partners
                </div>
                <div className="text-600">
                  Partner with FlexNet to bring cutting-edge solutions to life.
                </div>
                <hr className="my-3 mx-0 border-top-1 border-bottom-none border-300" />
                <div className="text-900 font-medium text-xl mb-2">
                  Who Are Solution Partners?
                </div>
                <div className="text-600">
                  Solution Partners are innovators—device manufacturers,
                  application developers, and technology providers—who offer
                  solutions that enhance industry verticals and are compatible
                  with private 4G/5G networks.
                </div>

                <hr className="my-3 mx-0 border-top-1 border-bottom-none border-300" />
                <div className="flex align-items-center">
                  <span className="font-bold text-2xl text-900">
                    Why Partner with FlexNet?
                  </span>
                  <span className="ml-2 font-medium text-600"></span>
                </div>
                <hr className="my-3 mx-0 border-top-1 border-bottom-none border-300" />
                <ul className="list-none p-0 m-0 flex-grow-1">
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                    <span>
                      Showcase your solutions on the FlexNet Marketplace and
                      reach global customers.
                    </span>
                  </li>
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                    <span>
                      Collaborate with FlexNet to innovate and address specific
                      industry challenges.
                    </span>
                  </li>
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                    <span>
                      Drive revenue by integrating your solutions with a
                      future-ready platform.
                    </span>
                  </li>
                </ul>

                <hr className="my-3 mx-0 border-top-1 border-bottom-none border-300" />
                <div className="flex align-items-center">
                  <span className="font-bold text-2xl text-900">
                    Join Us if You:
                  </span>
                  <span className="ml-2 font-medium text-600"></span>
                </div>
                <hr className="my-3 mx-0 border-top-1 border-bottom-none border-300" />
                <ul className="list-none p-0 m-0 flex-grow-1">
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                    <span className="text-left">
                      Offer devices or applications relevant to industry
                      verticals like manufacturing, logistics, construction,
                      mining or ports.
                    </span>
                  </li>
                  <li className="flex align-items-center mb-3 text-left">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                    <span className="text-left">
                      Are ready to scale your solutions with private 4G/5G
                      connectivity.
                    </span>
                  </li>
                </ul>
                <hr className="mb-3 mx-0 border-top-1 border-bottom-none border-300" />
                <button className=" partners-button shadow-lg">
                  <Link to="/contact">Contact</Link>
                </button>
              </div>
            </div>
          </div>

          <div className="col-12 lg:col-6">
            <div className="p-3 h-full">
              <div
                className="chose-box shadow-2 p-3 flex flex-column"
                style={{ borderRadius: "6px" }}
              >
                <div className="text-900 font-medium text-xl mb-2">
                  Reseller Partners
                </div>
                <div className="text-600">
                  Expand your portfolio and drive growth with FlexNet.
                </div>
                <hr className="my-3 mx-0 border-top-1 border-bottom-none border-300" />
                <div className="text-900 font-medium text-xl mb-2">
                  Who Are Reseller Partners?
                </div>
                <div className="text-600">
                  Reseller Partners are trusted providers who promote and sell
                  FlexNet solutions and Marketplace applications across
                  industries and geographies.
                </div>
                <hr className="my-3 mx-0 border-top-1 border-bottom-none border-300" />
                <div className="flex align-items-center">
                  <span className="font-bold text-2xl text-900">
                    Why Partner with FlexNet?
                  </span>
                  <span className="ml-2 font-medium text-600"></span>
                </div>
                <hr className="my-3 mx-0 border-top-1 border-bottom-none border-300" />
                <ul className="list-none p-0 m-0 flex-grow-1 pt-4">
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                    <span>
                      Access a robust private 4G/5G solution portfolio to meet
                      customer needs.
                    </span>
                  </li>
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                    <span>
                      Leverage the FlexNet Marketplace to offer diverse
                      solutions to your clients.
                    </span>
                  </li>
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                    <span>
                      Receive dedicated support, training, and marketing
                      resources to drive success.
                    </span>
                  </li>
                </ul>
                <hr className="my-3 mx-0 border-top-1 border-bottom-none border-300" />
                <div className="flex align-items-center">
                  <span className="font-bold text-2xl text-900">
                    Join Us if You:
                  </span>
                  <span className="ml-2 font-medium text-600"></span>
                </div>
                <hr className="my-3 mx-0 border-top-1 border-bottom-none border-300" />
                <ul className="list-none p-0 m-0 flex-grow-1">
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                    <span className="text-left">
                      Have an established presence in one or more industries or
                      geographies.
                    </span>
                  </li>
                  <li className="flex align-items-center mb-3 text-left">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                    <span className="text-left">
                      Are committed to selling FlexNet and Marketplace
                      applications to drive innovation.
                    </span>
                  </li>
                </ul>
                <hr className="mb-3 mx-0 border-top-1 border-bottom-none border-300" />

                <button className="partners-button  shadow-lg">
                  <Link to="/contact">Contact</Link>
                </button>
              </div>
            </div>
          </div>
        </div>

        <h3 className="text-900 font-bold text-3xl mb-7 mt-7 text-center">
          Why Partner with FlexNet?
        </h3>
        <ul className="list-none p-0 m-0 flex-grow-1 partner-page-bottom-list">
          <li className="flex align-items-center mb-3 text-700 text-2xl">
            <i className="pi pi-check-circle text-green-500 mr-2"></i>
            <span className=" font-bold mr-1">Innovative Solutions:</span>
            Be part of the cutting edge in private 4G/5G technology.
          </li>

          <li className="flex align-items-center mb-3 text-700 text-2xl">
            <i className="pi pi-check-circle text-green-500 mr-2"></i>
            <span className=" font-bold mr-1">Global Reach:</span>
            Tap into a growing ecosystem of customers and industries.
          </li>

          <li className="flex align-items-center mb-3 text-700 text-2xl">
            <i className="pi pi-check-circle text-green-500 mr-2"></i>
            <span className=" font-bold mr-1">Revenue Growth:</span>
            Boost your revenue with a proven, scalable connectivity platform.
          </li>

          <li className="flex align-items-center mb-3 text-700 text-2xl">
            <i className="pi pi-check-circle text-green-500 mr-2"></i>
            <span className=" font-bold mr-1">Comprehensive Support:</span>
            Enjoy training, co-marketing, and technical support tailored to your
            success.
          </li>
        </ul>
      </div>
      <div className="faq-page-bottom mt-7">
        <h2>Got any more questions?</h2>
        <button className="contact-button">
          <Link to="/contact-us">Contact With Us</Link>
        </button>
      </div>
    </div>
  );
}
